<template>
    <div class="consultation-academician">
        <bread-crumb :bread-list="breadList" />

        <div class="consultation-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">院士会诊</span>
            </div>
            <div class="add-wrap">
                <el-button @click="handleAddNew">新增院士团队</el-button>
            </div>
            <div class="table-wrap">
                <el-table :data="dataList"
                          v-loading="loading"
                          stripe
                          style="width: 100%">
                    <el-table-column label="序号"
                                     width="80px">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="院士团队名称"
                                     prop="name">
                    </el-table-column>

                    <el-table-column label="团队人数"
                                     prop="count">
                    </el-table-column>
                    <el-table-column label="团队成员"
                                     width="400px">
                        <template slot-scope="{row}">
                            <div class="members-name">
                                <el-tooltip class="item"
                                            effect="dark"
                                            :content="row.membersName"
                                            placement="top">
                                    <span> {{ row.membersName }}</span>
                                </el-tooltip>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="{row}">
                            <div v-if="row.state === 'ONLINE'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="success"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已上线</span>
                            </div>
                            <div v-if="row.state === 'OFFLINE'"
                                 class="status-warp">
                                <el-badge is-dot
                                          type="info"
                                          class="item">
                                </el-badge>
                                <span class="status_text">已下线</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="排序">
                        <template slot-scope="{row}">
                            <div class="status-on">
                                <i class="iconfont icon-paixushang icon-off"
                                   v-if="row.noMoveUp"></i>
                                <i class="iconfont icon-paixushang icon-on"
                                   v-else
                                   @click="handleMoveIndex(row.groupId, 'UP')"></i>

                                <i class="iconfont icon-paixuxia icon-off"
                                   v-if="row.noMoveDown"></i>
                                <i class="iconfont icon-paixuxia icon-on"
                                   v-else
                                   @click="handleMoveIndex(row.groupId, 'DOWN')"></i>

                                <i class="iconfont icon-zhiding icon-off"
                                   v-if="row.noMoveUp"></i>
                                <i class="iconfont icon-zhiding icon-on"
                                   @click="handleMoveTop(row.groupId)"
                                   v-else></i>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作"
                                     width="180px">
                        <template slot-scope="{row}">
                            <div v-if="row.state === 'ONLINE'">
                                <span class="link-btn"
                                      @click="handlePutState(row)">下线</span>
                                <span class="link-btn"
                                      @click="handleEditClick(row)">编辑</span>
                                <span class="link-btn"
                                      @click="hanldeDeleMessage(row)">删除</span>
                            </div>
                            <div v-if="row.state === 'OFFLINE'">
                                <span class="link-btn"
                                      @click="handlePutState(row)">上线</span>
                                <span class="link-btn"
                                      @click="handleEditClick(row)">编辑</span>
                                <span class="link-btn"
                                      @click="hanldeDeleMessage(row)">删除</span>
                            </div>
                        </template>
                    </el-table-column>
                    <div slot="empty"
                         class="table-none">
                        <div>
                            <svg-icon icon-class="none1" />
                        </div>
                        <span>暂无数据</span>
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handleCurrentChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>

        <el-drawer :visible.sync="drawer"
                   :wrapper-closable="false"
                   size="500px"
                   custom-class="academician-drawer">
            <div class="drawer-wraper">
                <div class="title-icon">
                    <i class="iconfont icon-tongyongbiaotiicon"></i>
                    <span class="title-text">{{ drawerTitle }}</span>
                </div>
                <div>
                    <i class="el-icon-close"
                       @click="drawer = false"></i>
                </div>
            </div>

            <el-form :model="drawerForm"
                     ref="drawerForm"
                     v-loading="drawerFormLoading"
                     label-width="132px"
                     class="drawer-form">
                <el-form-item label="团队名称"
                              prop="name"
                              :rules="[{ required: true, message: '请输入团队名称', trigger: 'change' }]">
                    <el-input v-model="drawerForm.name"
                              class="form-input"
                              placeholder="请输入团队名称"></el-input>
                </el-form-item>

                <el-form-item label="团队成员"
                              prop="memberIdList"
                              :rules="[{ required: true, message: '请选择团队成员', trigger: 'change' }]">
                    <div class="add-member"
                         @click="handleAddDoctor">
                        <i class="el-icon-circle-plus-outline"></i>
                        <span class="icon-text">选择团队成员</span>
                    </div>
                    <draggable :set-data="setData"
                               class="drag-area"
                               v-model="drawerForm.memberIdList">
                        <div v-for="(item, index) in drawerForm.memberIdList"
                             :key="index">
                            <div class="item-data">
                                <i class="iconfont icon-user1"></i>
                                <span class="data-text">{{item.name}}</span>
                                <i class="el-icon-close"
                                   @click="hanldeDeleListMember(item, index)"></i>
                            </div>
                        </div>
                    </draggable>
                </el-form-item>

            </el-form>

            <div class="drawer-bottom">
                <el-button class="confirm-btn"
                           @click="handleAddGroup">确 定</el-button>
                <el-button class="cancle-btn"
                           @click="drawer = false">取 消</el-button>
            </div>
        </el-drawer>

        <el-dialog title="选择团队成员"
                   :visible.sync="dialogVisible"
                   custom-class="member-dialog"
                   :before-close="handleBeforeClose"
                   :close-on-click-modal="false"
                   width="560px">
            <div class="member-content">
                <div class="left-wraper">
                    <div class="search-content">
                        <el-input class="search-doctor"
                                  placeholder="请输入医生姓名查询"
                                  v-model="memberForm.doctorName"
                                  @keyup.enter.native="queryDoctorList">
                            <i slot="suffix"
                               class="iconfont icon-search"
                               @click="queryDoctorList"></i>
                        </el-input>
                    </div>

                    <div class="table-content">
                        <el-table :data="doctorList"
                                  stripe
                                  v-loading="doctorLoading"
                                  ref="doctorTable"
                                  height="400px"
                                  style="width: 333px">
                            <el-table-column label="姓名"
                                             prop="name"
                                             width="60px">
                            </el-table-column>
                            <el-table-column label="工号"
                                             width="70px"
                                             prop="staffNo">
                            </el-table-column>
                            <el-table-column label="科室"
                                             width="75px"
                                             prop="deptName">
                            </el-table-column>
                            <el-table-column label="职称"
                                             width="75px"
                                             prop="titleValue">
                            </el-table-column>
                            <el-table-column width="50px">
                                <template slot-scope="{row}">
                                    <el-checkbox v-model="row.selected"
                                                 @change="checked=>rowSelectedChange(checked, row)"></el-checkbox>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>

                </div>
                <div class="right-wraper">
                    <div class="content_text">
                        <div class="choose_text">已选择（{{ chooseData.length }}）</div>
                        <div class="empty_text"
                             @click="handleClear">清空</div>
                    </div>
                    <div class="choose-member">
                        <div v-for="(item, index) in chooseData"
                             :key="index"
                             class="item-member">
                            <div>
                                <i class="iconfont icon-user1"></i>
                                <label class="member-text">{{item.name}}</label>
                            </div>
                            <div>
                                <i class="el-icon-close"
                                   @click="hanldeDeleMember(item, index)"></i>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
            <span slot="footer"
                  class="dialog-footer">
                <el-button type="primary"
                           @click="chooseMember"
                           class="dialog-confirm-btn">确 定</el-button>
                <el-button @click="dialogVisible = false;memberForm.doctorName = ''"
                           class="dialog-cancle">取 消</el-button>
            </span>
        </el-dialog>

        <message-box :dialog-visible="messageVisible"
                     :id="groupId"
                     warning-text="您确定要删除该团队吗？"
                     @handleConfirm="handleMessageConfirm"
                     @handleClose="handleMessageClose" />

    </div>
</template>

<script>
import draggable from 'vuedraggable'
import MessageBox from '@/components/MessageBox'
import { putGroupChangeIndexTop, putGroupChangeIndex, postClinicGroupList, deleteClinicGroup, postChoseDoctorList, postAddClinicGroup, putClinicGroupState, postClinicMemberList, postClinicGroupUpdate } from '@/api/consultation'
export default {
    name: 'consultationAcademician',
    data () {
        return {
            loading: false,
            drawer: false,
            dialogVisible: false,
            messageVisible: false,
            doctorLoading: false,
            drawerFormLoading: false,
            breadList: [{ label: '运营管理' }, { label: '会诊管理', path: '/operation/consultation' }, { label: '院士会诊编辑' }],
            dataList: [],
            doctorList: [],
            chooseData: [],
            drawerForm: {
                name: '',
                memberIdList: []
            },
            memberForm: {
                doctorName: ''
            },
            drawerType: '',
            drawerTitle: '',
            clinicId: this.$route.query.clinicId,
            groupId: '',
            page: {
                current: 1,
                total: 1,
                pageSize: 15
            }
        }
    },
    components: { draggable, MessageBox },
    methods: {
        // 上下线
        async handlePutState (row) {
            let state = ''
            let message = ''
            if (row.state === 'ONLINE') {
                state = 'OFFLINE'
                message = '下线成功'
            } else if (row.state === 'OFFLINE') {
                state = 'ONLINE'
                message = '上线成功'
            }
            const { results } = await putClinicGroupState(row.groupId, state)
            if (results === 'success') {
                this.$message({
                    message: message,
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.queryList(this.page.current)
            }
        },
        // 上移   下移
        async handleMoveIndex (groupId, type) {
            const { results } = await putGroupChangeIndex(groupId, type)
            if (results === 'success') {
                this.queryList(this.page.current)
            }
        },
        // 置顶
        async handleMoveTop (groupId) {
            const { results } = await putGroupChangeIndexTop(groupId)
            if (results === 'success') {
                this.queryList(this.page.current)
            }
        },
        async handleEditClick (row) {
            const { name, groupId } = row
            this.drawerFormLoading = true
            this.drawerType = 'edit'
            this.drawerTitle = '编辑院士团队'
            this.drawer = true
            this.memberForm.doctorName = ''
            this.drawerForm.name = name
            this.drawerForm.groupId = groupId
            this.queryMember(groupId)
        },
        async  queryMember (groupId) {
            let params = {
                clinicId: this.clinicId,
                groupId: groupId,
                page: 1,
                size: 1000
            }
            this.drawerForm.memberIdList = []
            const { results } = await postClinicMemberList(params)
            this.drawerForm.memberIdList = results
            this.drawerFormLoading = false
        },
        handleBeforeClose (done) {
            this.memberForm.doctorName = ''
            done()
        },
        hanldeDeleMessage (row) {
            this.messageVisible = true
            this.groupId = row.groupId
        },
        handleMessageClose () {
            this.messageVisible = false
        },
        async handleMessageConfirm (groupId) {
            const { state } = await deleteClinicGroup(groupId)
            if (state === 200) {
                this.$message({
                    message: '成功删除该团队',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.messageVisible = false
                this.queryList(this.page.current)
            }
        },
        setData (dataTransfer) {
            dataTransfer.setData('Text', '')
        },
        handleCurrentChange (val) {
            this.page.current = val
            this.queryList()
        },
        // 点击新增院士团队
        handleAddNew () {
            this.drawer = true
            if (this.$refs['drawerForm']) {
                this.$refs['drawerForm'].resetFields()
            }
            this.drawerType = 'add'
            this.drawerTitle = '新增院士团队'
            this.drawerForm.name = ''
            this.drawerForm.memberIdList = []
            this.chooseData = []
        },
        // 多选框选择事件
        rowSelectedChange (checked, row) {
            if (checked) {
                this.chooseData.push(row)
            } else {
                let index = this.chooseData.findIndex(value => value.relationId === row.relationId)
                this.chooseData.splice(index, 1)
            }
        },
        handleAddDoctor () {
            this.dialogVisible = true
            let memberIdList = this.drawerForm.memberIdList
            if (memberIdList.length > 0) {
                this.chooseData = JSON.parse(JSON.stringify(memberIdList))
            }
            this.queryDoctorList()
        },
        // 选择团队成员 查询
        async queryDoctorList () {
            let params = {
                doctorName: this.memberForm.doctorName,
                page: 1,
                size: 1000
            }
            this.doctorList = []
            this.doctorLoading = true
            const { results } = await postChoseDoctorList(params)
            let members = results.members
            this.doctorList = members
            this.doctorLoading = false
            let data = this.chooseData
            if (data.length > 0) {
                // 选择成员 和 results中 存在相同的，则 table 选中
                for (let i = 0; i < members.length; i++) {
                    for (let j = 0; j < data.length; j++) {
                        if (members[i].relationId === data[j].relationId) {
                            this.$set(members[i], 'selected', true)
                        }
                    }
                }
            }
        },

        // 选择专家组团队清空
        handleClear () {
            this.chooseData = []
            let data = this.doctorList
            for (let i = 0; i < data.length; i++) {
                this.$set(data[i], 'selected', false)
            }
        },
        // 确定选择团队成员
        chooseMember () {
            this.drawerForm.memberIdList = this.chooseData
            this.dialogVisible = false
            this.$refs['drawerForm'].validateField('memberIdList')
            this.memberForm.doctorName = ''
        },
        // 删除单个选中的成员
        hanldeDeleMember (row, index) {
            this.chooseData.splice(index, 1)
            let data = this.doctorList
            let number = data.findIndex(value => value.relationId === row.relationId)
            if (number >= 0) {
                this.$set(data[number], 'selected', false)
            }
        },
        hanldeDeleListMember (row, index) {
            this.drawerForm.memberIdList.splice(index, 1)
        },
        handleAddGroup () {
            this.$refs['drawerForm'].validate((valid) => {
                if (valid) {
                    this.saveClinicGroup()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        },
        async saveClinicGroup () {
            let memberIdList = []
            let data = this.drawerForm.memberIdList
            for (let i = 0; i < data.length; i++) {
                memberIdList.push(data[i].relationId)
            }
            this.drawerFormLoading = true
            if (this.drawerType === 'add') {
                let params = {
                    clinicId: this.clinicId,
                    name: this.drawerForm.name,
                    memberIdList: memberIdList,
                    type: 'EXPERTER'
                }

                const { results } = await postAddClinicGroup(params)
                if (results) {
                    this.$message({
                        message: '成功新增院士团队',
                        customClass: 'hos-message--success',
                        iconClass: 'el-icon-success',
                        duration: '2000'
                    })
                    this.drawer = false
                    this.queryList()
                }
                this.drawerFormLoading = false
            }

            if (this.drawerType === 'edit') {
                let params = {
                    name: this.drawerForm.name,
                    groupId: this.drawerForm.groupId,
                    memberIdList: memberIdList
                }
                const { results } = await postClinicGroupUpdate(params)
                if (results) {
                    this.$message({
                        message: '成功编辑院士团队',
                        customClass: 'hos-message--success',
                        iconClass: 'el-icon-success',
                        duration: '2000'
                    })
                    this.drawer = false
                    this.queryList()
                }
                this.drawerFormLoading = false
            }
        },
        // 团队成员列表
        async queryList () {
            let params = {
                clinicId: this.clinicId,
                page: this.page.current,
                type: 'EXPERTER',
                size: this.page.pageSize
            }
            this.dataList = []
            this.loading = true
            const { results, total } = await postClinicGroupList(params)
            if (results && results.length > 0) {
                for (let i = 0; i < results.length; i++) {
                    let data = results[i]
                    if (data.orderIndexFlag === 'first') {
                        this.$set(data, 'noMoveUp', true)
                    }
                    if (data.orderIndexFlag === 'last') {
                        this.$set(data, 'noMoveDown', true)
                    }
                }
                this.dataList = results
                this.page.total = total
            } else {
                if (this.page.current > 1) {
                    this.page.current -= 1
                    this.queryList()
                }
            }
            this.loading = false
        }
    },
    mounted () {
        this.queryList()
    }
}
</script>

<style lang="scss">
.consultation-academician {
    .consultation-content {
        min-height: 600px;
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        background: #fff;
        overflow: auto;
        padding: 20px 20px 0 20px;
        .title-wrap {
            padding-bottom: 20px;
            display: flex;
            align-items: center;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }
        .add-wrap {
            margin-bottom: 20px;
            .el-button {
                height: 32px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                border-radius: 3px;
                padding: 0 14px;
            }
        }
        .table-wrap {
            .members-name {
                width: 380px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
            }
            .status-warp {
                line-height: 12px;
                .el-badge {
                    height: 10px;
                    .el-badge__content {
                        width: 6px;
                        height: 6px;
                    }
                    .el-badge__content--success {
                        background: #4acfb1;
                    }
                    .el-badge__content--info {
                        background: #cccccc;
                    }
                }
                .status_text {
                    margin-left: 10px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    line-height: 12px;
                }
            }

            .status-on {
                display: flex;
                align-items: center;
                .icon-off {
                    color: #ccc;
                }
                .icon-on {
                    cursor: pointer;
                    color: #3b8fd9;
                }
                .icon-paixuxia {
                    font-size: 16px;
                    margin-right: 10px;
                }
                .icon-paixushang {
                    font-size: 16px;
                    margin-right: 10px;
                }
                .icon-zhiding {
                    font-size: 20px;
                }
            }
            .table-none {
                height: 400px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .icon {
                    font-size: 100px;
                }
                span {
                    line-height: 14px;
                }
            }
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
        }
    }
}
// .el-dialog__wrapper
.el-dialog__wrapper, .el-drawer__wrapper {
    .academician-drawer {
        .el-drawer__header {
            display: none;
        }
        .el-drawer__body {
            position: relative;
            overflow: auto;
            .drawer-wraper {
                margin: 20px;
                display: flex;
                justify-content: space-between;
                border-bottom: 1px solid #ccc;
                padding-bottom: 10px;
                .title-icon {
                    display: flex;
                    align-items: center;
                    .icon-tongyongbiaotiicon {
                        color: $color-primary;
                        font-size: 16px;
                        vertical-align: middle;
                    }
                    .title-text {
                        font-size: 14px;
                        color: #4a4a4a;
                        margin-left: 10px;
                        display: inline-block;
                        height: 16px;
                        line-height: 16px;
                        vertical-align: middle;
                    }
                }
                .el-icon-close {
                    cursor: pointer;
                    color: #999;
                    font-size: 20px;
                }
            }
            .drawer-form {
                margin-top: 20px;
                .el-form-item__label {
                    padding-right: 20px;
                }
                .form-input {
                    width: 250px;
                    .el-input__inner {
                        border-radius: 3px;
                        border: 1px solid #dcdcdc;
                        height: 32px;
                        padding: 0 10px;
                        height: 32px;
                        border-radius: 3px;
                    }
                }
                .add-member {
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    .el-icon-circle-plus-outline {
                        font-size: 18px;
                        color: #06aea6;
                    }
                    .icon-text {
                        margin-left: 8px;
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #06aea6;
                    }
                }
                .drag-area {
                    margin-top: 5px;
                    padding-bottom: 60px;
                    display: flex;
                    flex-wrap: wrap;
                    .item-data {
                        cursor: pointer;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        height: 24px;
                        line-height: 24px;
                        padding: 0 8px;
                        background: #ffffff;
                        border: 1px solid #f2f2f2;
                        border-radius: 3px;
                        &:active {
                            opacity: 0.2;
                            background: #999;
                        }
                        .icon-user1 {
                            font-size: 12px;
                            color: #06aea6;
                        }
                        .data-text {
                            margin-left: 10px;
                            font-family: PingFangSC-Regular;
                            font-size: 14px;
                            color: #333333;
                        }
                        .el-icon-close {
                            color: #999;
                            font-size: 12px;
                            margin-left: 10px;
                        }
                    }
                }
            }
            .drawer-bottom {
                position: fixed;
                bottom: 0;
                right: 0;
                background: #f7f7f7;
                width: 500px;
                height: 60px;
                display: flex;
                align-items: center;
                justify-content: center;
                .confirm-btn {
                    background: #ff7631;
                    border-radius: 3px;
                    width: 120px;
                    height: 34px;
                    padding: 0;
                    border: none;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #ffffff;
                }
                .cancle-btn {
                    width: 120px;
                    height: 34px;
                    padding: 0;
                    background: #f5f5f5;
                    border: 1px solid #d6d6d6;
                    border-radius: 3px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    margin-left: 16px;
                }
            }
        }
    }
}
.el-dialog__wrapper {
    .member-dialog {
        border-radius: 3px;
        .el-dialog__body {
            padding: 0;
            .member-content {
                height: 453px;
                display: flex;
                .left-wraper {
                    padding-left: 10px;
                    width: 340px;
                    border-right: 1px solid #dcdcdc;
                    .search-content {
                        margin-top: 10px;
                        .search-doctor {
                            width: 319px;
                            vertical-align: middle;
                            .el-input__inner {
                                border-radius: 3px;
                                border-color: #dcdcdc;
                                padding: 8px 32px 8px 10px;
                                height: 32px;
                                font-size: 12px;
                                &::-webkit-input-placeholder {
                                    font-size: 12px;
                                }
                            }

                            .el-input__suffix {
                                background: $color-primary;
                                color: #fff;
                                right: 0;
                                cursor: pointer;
                                border-radius: 0 3px 3px 0;

                                i {
                                    display: inline-block;
                                    width: 36px;
                                    font-size: 14px;
                                    line-height: 32px;
                                    border-radius: 3px;
                                }
                            }
                        }
                    }
                    .table-content {
                        margin-top: 10px;
                    }
                }
                .right-wraper {
                    width: 220px;
                    padding: 20px 0 20px 20px;
                    .content_text {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .choose_text {
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #999999;
                            letter-spacing: 0;
                        }
                        .empty_text {
                            cursor: pointer;
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #198eeb;
                            letter-spacing: 0;
                            margin-right: 20px;
                        }
                    }
                    .choose-member {
                        margin-top: 20px;
                        height: 390px;
                        overflow: auto;
                        padding-right: 14px;
                        .item-member {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 10px;
                            .icon-user1 {
                                font-size: 14px;
                                color: #06aea6;
                            }
                            .el-icon-close {
                                color: #999;
                                font-size: 14px;
                                cursor: pointer;
                            }
                            .member-text {
                                margin-left: 10px;
                                font-family: PingFangSC-Regular;
                                font-size: 12px;
                                color: #333333;
                                letter-spacing: 0;
                            }
                        }
                    }
                }
            }
        }
        .el-dialog__footer {
            background: #f9f9f9;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            .dialog-footer {
                .dialog-confirm-btn {
                    width: 100px;
                    height: 32px;
                    padding: 0;
                }
                .dialog-cancle {
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    border-radius: 3px;
                    padding: 0;
                    width: 100px;
                    height: 32px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    margin-left: 16px;
                }
            }
        }
    }
}
</style>
